// Premium toast with icon + animation.

let container = null;

function ensure() {
  if (container && document.body.contains(container)) return container;
  container = document.createElement('div');
  container.id = 'toast-container';
  document.body.appendChild(container);
  return container;
}

const ICONS = {
  info: 'ℹ️',
  success: '✅',
  warning: '⚠️',
  error: '❌',
};

export function toast(message, { type = 'info', duration = 3000, icon } = {}) {
  const root = ensure();
  const el = document.createElement('div');
  el.className = `toast ${type}`;
  el.innerHTML = `
    <span class="toast-icon">${icon || ICONS[type] || ICONS.info}</span>
    <span class="toast-content">${escapeHtml(message)}</span>
  `;
  root.appendChild(el);

  setTimeout(() => {
    el.style.animation = 'toast-out 0.25s forwards';
    setTimeout(() => el.remove(), 250);
  }, duration);
}

function escapeHtml(s = '') {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

if (typeof window !== 'undefined') window.toast = toast;
